import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

import { expirationDurations } from 'services/cookie.service'

export const useLeftControls = (): [boolean, (value: boolean) => void] => {
  const keyAndClassName = 'left-hand-controls'

  const [{ [keyAndClassName]: leftControlsEnabled }, setCookies] = useCookies([keyAndClassName])

  const enabled = leftControlsEnabled === 'true'

  const handleSetLeftHandControls = (enabled: boolean) => {
    setCookies(keyAndClassName, enabled, { maxAge: expirationDurations.year, path: '/' })

    if (enabled) document.body.classList.add(keyAndClassName)
    else document.body.classList.remove(keyAndClassName)
  }

  useEffect(() => {
    handleSetLeftHandControls(enabled)
  }, [enabled])

  return [enabled, handleSetLeftHandControls]
}

export const useHideFloatingToolbar = (): [boolean, (value: boolean) => void] => {
  const key = 'no-hide-floating-toolbar'

  const [{ [key]: noHideFloatingToolbar }, setCookies] = useCookies([key])

  const enabled = noHideFloatingToolbar === 'true'

  const handleSetNoHideFloatingToolbar = (enabled: boolean) =>
    setCookies(key, enabled, { maxAge: expirationDurations.year, path: '/' })

  useEffect(() => {
    handleSetNoHideFloatingToolbar(enabled)
  }, [enabled])

  return [enabled, handleSetNoHideFloatingToolbar]
}
